export type TokenScope = {
  orgId: string | undefined;
  wsId: string | undefined;
};

export const decodeTokenScope = (
  token: string | null | undefined,
): TokenScope => {
  if (!token) {
    return { orgId: undefined, wsId: undefined };
  }
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return {
      orgId: payload.scope_org_id ?? undefined,
      wsId: payload.scope_ws_id ?? undefined,
    };
  } catch {
    return { orgId: undefined, wsId: undefined };
  }
};
